import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../constant/fieldNames"
import getDisplayCondition from "../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../types"
import OneClickField from "../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../constant/helpLinks"

const 無料提供部品 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { freeMaterialsFlg: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField isShow={shouldShow} legend="P板.com無料提供部品" helpURL={HELP_LINKS["P板.com無料提供部品"]}>
      <RadioGroup
        name={FIELD_NAMES["P板.com無料提供部品"]}
        selectedValue={values.freeMaterialsFlg}
        onChange={handlers.radio}
      >
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["P板.com無料提供部品"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["P板.com無料提供部品"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.freeMaterialsFlg} />
    </OneClickField>
  )
}

export default 無料提供部品
